export const tableHeaders = [
  {
    key: 'Delete',
    apiAlias: null,
    value: 'Delete',
  },
  {
    key: 'ApplicationName',
    apiAlias: 'application_name',
    value: 'Application Name',
  },
  {
    key: 'ApplicationID',
    apiAlias: 'application_id',
    value: 'Application ID',
  },
  {
    key: 'MerchantName',
    apiAlias: 'merchant_name',
    value: 'Merchant Name',
  },
  {
    key: 'MerchantID',
    apiAlias: 'merchant_id',
    value: 'Merchant ID',
  },
  {
    key: 'StartDateTime',
    apiAlias: 'start_date_time',
    value: 'Start Date Time',
  },
  {
    key: 'EndDateTime',
    apiAlias: 'end_date_time',
    value: 'End Date Time',
  },
  {
    key: 'Kind',
    apiAlias: 'kind',
    value: 'Kind',
  },
  {
    key: 'FundedBy',
    apiAlias: 'funded_by',
    value: 'Funded By',
  },
  {
    key: 'CreatedDate',
    apiAlias: 'created_date',
    value: 'Created Date',
  },
];
